import UiResource from './UiResource'
import { store } from '@/store/store'

class CustomFilterResource extends UiResource {
    async indexAsOptions(componentCode) {
        const customFilters = await this.index(componentCode)
        return customFilters.map(i => ({
            id: i.id,
            componentId: i.componentId,
            label: i.filterName,
            filterModel: i.filterCriteria ? i.filterCriteria.filterModel : null,
            url: i.filterCriteria ? i.filterCriteria.url : null,
            task: i.filterCriteria ? i.filterCriteria.task : null,
            type: i.filterCriteria ? i.filterCriteria.type : null,
            externalFilterModel: i.filterCriteria ? i.filterCriteria.externalFilterModel : null,
            customFilterModel: i.filterCriteria ? i.filterCriteria.customFilterModel : null,
            uicomponent: i.filterCriteria ? i.filterCriteria.uicomponent : null,
            caseSituation: i.filterCriteria?.caseSituation
        }))
    }
    // TODO SEGUIR EN APATH-1684
    // async indexAsOptionsDiagnosis(componentCode) {
    //     const customFilters = await this.index(componentCode)
    //     return customFilters.map(i => ({
    //         id: i.id,
    //         componentId: i.componentId,
    //         label: i.filterName,
    //         filterModel: i.filterCriteria.filterModel,
    //         caseSituation: i.filterCriteria.caseSituation
    //     }))
    // }
    async deleteCustomOption(componentCode, option) {
        const laboratoryId = store.getters.labId
        const params = { laboratoryId }
        return this.axios.delete(`/uicomponents/${componentCode}/customfilters/${option.id}`, { params })
    }
    async renameCustomOption(componentCode, option) {
        const { id, label, caseSituation, ...customFilter } = option
        const optionData = { id, label, caseSituation }
        return this.updateCustomOption(componentCode, optionData, customFilter)
    }
    async updateCustomOption(componentCode, option, customFilter) {
        const laboratoryId = store.getters.labId
        const params = { laboratoryId }
        const data = {
            filterName: option.label,
            filterCriteria: {
                filterModel: customFilter.filterModel,
                url: customFilter.url,
                task: customFilter.task,
                externalFilterModel: customFilter.externalFilterModel,
                customFilterModel: customFilter.customFilterModel,
                type: customFilter.type,
                uicomponent: customFilter.uicomponent,
                caseSituation: option.caseSituation
            }
        }
        return this.axios.put(`/uicomponents/${componentCode}/customfilters/${option.id}`, data, { params })
    }
    async index(componentCode) {
        const laboratoryId = store.getters.labId
        const params = { laboratoryId }
        const response = await this.axios.get(`/uicomponents/${componentCode}/customfilters`, { params })
        return response.data
    }
    async create(componentCode, customFilter) {
        this.validateCustomFilter(customFilter)
        const laboratoryId = store.getters.labId
        const params = { laboratoryId }
        const data = {
            filterName: customFilter.label,
            filterCriteria: {
                filterModel: customFilter.filterModel,
                url: customFilter.url,
                task: customFilter.task,
                externalFilterModel: customFilter.externalFilterModel,
                customFilterModel: customFilter.customFilterModel,
                type: customFilter.type,
                uicomponent: customFilter.uicomponent,
                caseSituation: customFilter.caseSituation
            }
        }
        return this.axios.post(`/uicomponents/${componentCode}/customfilters`, data, { params })
    }
    // TODO SEGUIR EN APATH-1684
    // async createDiagnosis(componentCode, customFilter) {
    //     const filters = {
    //         filterModel: customFilter.filterModel,
    //         caseSituation: customFilter.caseSituation
    //     }
    //     this.validateCustomFilter(customFilter)
    //     const laboratoryId = store.getters.labId
    //     const params = { laboratoryId }
    //     const data = {
    //         filterName: customFilter.label,
    //         filterCriteria: filters
    //     }
    //     return this.axios.post(`/uicomponents/${componentCode}/customfilters`, data, { params })
    // }
    validateCustomFilter(customFilter) {
        if (!customFilter.label || !customFilter.filterModel) {
            throw new Error(`invalid customFilter, must include label and filterModel`)
        }
    }
}

export default new CustomFilterResource()
